import React from 'react'

import Popup from 'reactjs-popup'
import { ButtonRound } from '../../../../components/Header/styles'
import { FaFilter } from 'react-icons/fa6'
import { Form } from '../../../../components/commons'
import { Container, Title } from './styles'
import { SelectDocumentType } from '../../../../components/Modals/ModalUpload'
import { useForm } from 'react-hook-form'
import { api } from '../../../../services/api'
import SelectInput from '../../../../components/Input/SelectInput'

export interface FavoriteProps {
  setFilter: (filter: any) => void
  filter: any
}

const Filters: React.FunctionComponent<FavoriteProps> = ({ setFilter, filter }) => {
  const [options, setOptions] = React.useState([])
  const {
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm<{ documentType: string; selectedIndex: string }>({})

  const documentType = watch('documentType')
  const selectedIndex = watch('selectedIndex')

  const onGetOptions = async () => {
    try {
      const { data: response } = await api.get(`/documentTypes/${documentType}`)
      setOptions(response.metadata)
    } catch (error) {}
  }

  React.useEffect(() => {
    setFilter({
      documentType,
      selectedIndex,
    })
  }, [documentType, selectedIndex])

  React.useEffect(() => {
    if (documentType && documentType !== '') {
      onGetOptions()
    }
  }, [documentType])

  React.useEffect(() => {
    setValue('documentType', filter?.documentType)
    setValue('selectedIndex', filter?.selectedIndex)
  }, [])

  return (
    <>
      <div id='portalMenu' />
      <Popup
        trigger={
          <button
            type="button"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Filtrar por tipo ou metadado"
            style={{
              height: 40,
              padding: '0 14px',
              borderRadius: 8,
              border: (filter?.documentType || filter?.selectedIndex) ? '1px solid #2c30af' : '1px solid rgba(0, 0, 0, 0.12)',
              backgroundColor: (filter?.documentType || filter?.selectedIndex) ? 'rgba(44, 48, 175, 0.12)' : 'rgba(255, 255, 255, 0.5)',
              color: (filter?.documentType || filter?.selectedIndex) ? '#2c30af' : '#334155',
              fontWeight: 600,
              fontSize: 13,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              whiteSpace: 'nowrap',
            }}
          >
            <FaFilter size={13} />
            <span>Filtros</span>
          </button>
        }
        position='bottom right'
      >
        <Container>
          <Form>
            <Title>Filtrar</Title>
            <SelectDocumentType
              menuPortalTarget={document.querySelector('#portalMenu')}
              menuPosition={'fixed'}
              control={control}
            />

            <SelectInput
              menuPortalTarget={document.querySelector('#portalMenu')}
              control={control}
              menuPosition={'fixed'}
              zIndex={9999}
              label='Selecionar Index'
              name='selectedIndex'
              isClearable
              options={options.map((op: any) => ({
                label: op.name,
                value: op.name,
              }))}
            />
          </Form>
        </Container>
      </Popup>
    </>
  )
}

export default Filters
